import styled, { css } from 'styled-components';
import { mediaQuery } from '~/src/styles/mixins';
import { rem } from '~/src/helpers/rem-converter.helper';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { COLORS } from '~/src/styles/tokens/colors';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { MAX_767 } from '~/src/styles/tokens/break-points';

export const Notification = styled.div<{ hasError: boolean; top?: number; widthSuccess?: number; widthError?: number }>`
    position: fixed;
    top: ${(p) => (p.top ? rem(p.top) : '10%')};
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: ${(p) => (p.hasError ? rem(p.widthError || 334) : rem(p.widthSuccess || 302))};
    padding: ${rem(8)} ${rem(12)};
    border-radius: ${BORDER_RADIUS.bigger12};
    z-index: ${Z_INDEX.level4};
    background-color: ${COLORS.backgroundLightInverted};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            top: 12%;
        `,
    )};
`;

export const TextNotification = styled.span`
    ${FONTS.compact.regular.size14};
    color: ${COLORS.textLightInverted};
    height: ${rem(20)};
    display: inline-block;
    margin-top: 2px;
`;

export const SvgSuccessNotificationWrapper = styled.div`
    margin-right: ${rem(8)};
    width: ${rem(24)};
    height: ${rem(24)};
    display: flex;
    align-items: center;
`;
